// Table.tsx
import React from "react";
import * as S from "./ChatInterfaceStyles";
import { ScheduleInterviewButton } from "./ChatInterfaceStyles";

export interface TableType {
  headers?: string[];
  rows: (string | number)[][];
}

interface TableProps {
  table: TableType;
  onScheduleInterview?: (candidateName: string) => void;
}

const Table: React.FC<TableProps> = ({ table, onScheduleInterview }) => {
  const handleScheduleInterviewClick = (candidateName: string) => {
    if (onScheduleInterview) {
      onScheduleInterview(candidateName);
    }
  };

  return (
    <S.TableWrapper>
      <S.StyledTable>
        {table.headers && (
          <thead>
            <tr>
              {table.headers.map((header, index) => (
                <S.TableHeader key={index}>{header}</S.TableHeader>
              ))}
              {onScheduleInterview && (
                <S.TableHeader key="schedule-interview-header">Schedule Interview</S.TableHeader>
              )}
            </tr>
          </thead>
        )}
        <tbody>
          {table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Array.isArray(row) ? (
                row.map((cell, cellIndex) => {
                  const header = table.headers ? table.headers[cellIndex] : "";
                  const isResumeLinkColumn = header === "📄"; // Check if it's the resume link column

                  if (isResumeLinkColumn && typeof cell === "string" && cell.startsWith("http")) {
                    return (
                      <S.TableCell key={cellIndex}>
                        <a href={cell} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: "5px", color: "#1a73e8", textDecoration: "underline" }}>
                          Resume <span role="img" aria-label="document">📄</span>
                        </a>
                      </S.TableCell>
                    );
                  }
                  return (
                    <S.TableCell key={cellIndex}>{cell}</S.TableCell>
                  );
                })
              ) : (
                <S.TableCell key={0}>{row}</S.TableCell>
              )}
              {onScheduleInterview && (
                <S.TableCell key={`schedule-interview-${rowIndex}`}>
                  <ScheduleInterviewButton onClick={() => handleScheduleInterviewClick(row[0] as string)}>Schedule Interview</ScheduleInterviewButton>
                </S.TableCell>
              )}
            </tr>
          ))}
        </tbody>
      </S.StyledTable>
    </S.TableWrapper>
  );
};

export default Table;
